import { toIsoWithTimeZone } from './../utils/dateUtils';
import { CommunicationTemplate } from './CommunicationTemplate';
import { Stakeholder } from './Stakeholder';
export class ContactCustomFields {
  private template: CommunicationTemplate;

  clientId: string;
  domainUrl: string;
  projectId: string;
  emailType: string;
  stakeholder: Stakeholder;
  startDate: string;
  updateDate: string;

  get startAutosaveDate() {
    return this.startDate ? new Date(this.startDate) : new Date('2000-01-01');
  }

  set startAutosaveDate(value: Date) {
    this.startDate = toIsoWithTimeZone(value);
  }

  get lastSyncDate() {
    return new Date(this.updateDate);
  }

  set lastSyncDate(value: Date) {
    this.updateDate = toIsoWithTimeZone(value);
  }

  get communicationTemplate() {
    return this.template;
  }

  set communicationTemplate(template: CommunicationTemplate) {
    const cleanTemplate = new CommunicationTemplate();

    for (const key in cleanTemplate) {
      // eslint-disable-next-line no-prototype-builtins
      if (!cleanTemplate.hasOwnProperty(key) || !template[key]) continue;
      cleanTemplate[key] = template[key];
    }

    this.template = cleanTemplate;
  }
}
